var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from "react";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { perkbox } from "@irati/ui/src/global/colors";
import { RouterLink } from "@irati/ui/src/Link";
import { TenantOnboardingStepStates } from "@irati/types";
import tracking from "@irati-tracking/tenant-setup";
import { generateReadableStepNumber, isPathActive } from "../../helpers";
import { StepLinkContainer, StepNumberContainer, StepNumberLabel, StepLabel, MarginIcon } from "./styled";
var StepLink = /** @class */ (function (_super) {
    __extends(StepLink, _super);
    function StepLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var _a = _this.props, stepId = _a.stepId, formatMessage = _a.formatMessage, step = __rest(_a, ["stepId", "formatMessage"]);
            var params = {
                step_name: formatMessage({ id: step.title }),
                step_id: stepId,
                step_number: step.order
            };
            tracking.navigateStep(params);
        };
        return _this;
    }
    StepLink.prototype.render = function () {
        var _a = this.props, title = _a.title, stepNumber = _a.stepNumber, state = _a.state, nestedPath = _a.nestedPath;
        var done = state === TenantOnboardingStepStates.Done;
        var skipped = state === TenantOnboardingStepStates.Skipped;
        return (React.createElement(RouterLink, { styled: false, to: nestedPath, onClick: this.handleClick },
            React.createElement(StepLinkContainer, { active: isPathActive(nestedPath) },
                React.createElement(StepNumberContainer, null,
                    React.createElement(StepNumberLabel, { done: done, large: true, flush: true }, generateReadableStepNumber(stepNumber))),
                React.createElement(StepLabel, { done: done, flush: true },
                    React.createElement(FormattedMessage, { id: title })),
                done && React.createElement(MarginIcon, { size: 20, icon: "tick", flush: true, color: perkbox.blue }),
                skipped && React.createElement(MarginIcon, { icon: "circleHollow", color: perkbox.blue }))));
    };
    return StepLink;
}(PureComponent));
export default injectIntl(StepLink);
